// import {Popover2} from "@blueprintjs/popover2";
import {Popover as PopoverOld} from "@blueprintjs/core";

const Popover = (props) => {
    const {content, position, children} = props;
    return (
        <PopoverOld
            content={content}
            interactionKind="click"
            placement={position}
        >
            {children}
        </PopoverOld>
    );
};

export default Popover;